import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';


/*
* How to use:
*    <LoyaltyCircle
*       percentFull={35}
*       text="Text inside circle"
*       color="#someHexColor"
*    />
*
*
* NOTE:
*     - Text length is not capped. It's up
*       to you to see what looks best.
*/



class LoyaltyCircle extends Component {

  static propTypes = {
    text: PropTypes.string,
    color: PropTypes.string,
    percentFull: PropTypes.number,
    strokeWidth: PropTypes.number,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    style: PropTypes.object,
  }

  static defaultProps = {
    text: null,
    color: '#ed1b2e',
    percentFull: 35,
    strokeWidth: 7,
    className: '',
    disabled: false,
    style: {},
  }

  constructor(props) {
    super(props);

    // 100 = viewBox width
    this.radius        = (100 / 2) - (props.strokeWidth/2);
    this.circumference = 2 * Math.PI * this.radius;
  }

  componentDidMount() {
    // setTimeout(() => {
      this.fillProgressBar();
      this.setTextForIE11();
    // }, 500);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.percentFull !== this.props.percentFull)
      this.fillProgressBar();
  }

  setTextForIE11() {
    const text = findDOMNode(this.text);
    const transform = window.getComputedStyle(text).getPropertyValue('transform');

    text.setAttribute('transform', transform);
  }

  fillProgressBar() {
    const { percentFull, disabled } = this.props;
    // First number is radians filled, second is radians unfilled
    // Ex: out of 100%, 40% filled, 60% unfilled - but in radians.
    const amtFilled = this.circumference * (percentFull / 100);
    const amtEmpty  = this.circumference * (100 - percentFull) / 100;
    var strokeDasharray = `${amtFilled} ${amtEmpty}`;

    if (disabled) strokeDasharray = `${amtEmpty} ${amtFilled}`;

    this.progressBar.setAttribute('stroke-dasharray', strokeDasharray);
  }

  createCircle() {
    const {
      color,
      strokeWidth,
      percentFull,
      disabled
    } = this.props;
    // const defaultStrokeDashArray = `0 ${this.circumference}`;
    const defaultStrokeDashArray = "1 3 6 9";

    var backCircleFinalClassName = 'LoyaltyCircle_circle';
    var frontCircleFinalClassName = 'LoyaltyCircle_circle';
    if (disabled) backCircleFinalClassName += ' LoyaltyCircle_circle_back--disabled';
    if (disabled) frontCircleFinalClassName += ' LoyaltyCircle_circle_front--disabled';

    return (
      <g>
        {/* Bottom Circle */}
        <circle
          className={backCircleFinalClassName}
          r={this.radius} cx="50" cy="50"
          stroke="#cecece"
          strokeWidth={strokeWidth}
        ></circle>

        {/* Front Circle */}
        <circle
          ref={n => (this.progressBar = n)}
          className={frontCircleFinalClassName}
          r={this.radius} cx="50" cy="50"
          stroke={color}
          strokeWidth={(percentFull > 0) ? strokeWidth : 0}
          strokeDasharray={defaultStrokeDashArray}
        ></circle>
      </g>
    );
  }

  createText() {
    const { text, color, disabled } = this.props;

    var finalClassName = 'LoyaltyCircle_text';
    if (disabled) finalClassName += ' LoyaltyCircle_text--disabled';

    return (
      <g>
        <text
          ref={n => (this.text = n)}
          className={finalClassName}
          x="50%" y="-43%"
          fill={color}
          textAnchor="middle"
        >
          {text}
        </text>
      </g>
    );
  }

  render() {
    const { text, className, style } = this.props;

    return (
      <div className={`LoyaltyCircle ${className}`} style={style}>
        <svg
	        width="100%"
          height="100%"
          viewBox="0 0 100 100"
        >

          {this.createCircle()}
          {text && this.createText()}

        </svg>
      </div>
    );
  }
}

export default LoyaltyCircle;



// WEBPACK FOOTER //
// ./src/components/LoyaltyCircle/LoyaltyCircle.js